import React from 'react';
import styled from 'styled-components';

import Section from '../../../../common/Section';
import AppTile from '../common/AppTile';
import { StyledAppGrid } from '../common/styles';

const MAX_APPS_SHOWN = 5;

const SimilarApps = (props) => {
  const { apps, appTitle } = props;

  if (apps.length === 0) return null;

  const shuffledAppIndexes = getRandomArray(apps.length);
  const shownAppIndexes = shuffledAppIndexes.slice(
    0,
    Math.min(MAX_APPS_SHOWN, apps.length)
  );

  const showApps = shownAppIndexes.map((i) => apps[i]);

  return (
    <Section>
      <StyledSimilarApps>
        <StyledHeading>Apps similar to {appTitle}</StyledHeading>
        <StyledAppGrid>
          {showApps.map((app) => (
            <AppTile
              key={app.id}
              slug={app.id}
              description={app.salesDescription}
              image={app.logo}
              name={app.title}
              developer={app.developerName}
            />
          ))}
        </StyledAppGrid>
      </StyledSimilarApps>
    </Section>
  );
};

const shuffleArray = (arr) =>
  arr
    .map((a) => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map((a) => a[1]);

const getRandomArray = (numberOfApps) => {
  const array = [];
  for (let i = 0; i < numberOfApps; i += 1) {
    array.push(i);
  }
  return shuffleArray(array);
};

const StyledHeading = styled.h3`
  font-size: var(--heading-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--blue-dark);
  margin-bottom: 40px;
`;

const StyledSimilarApps = styled.div`
  padding: 80px 0 205px 0;
  border-top: 1px solid var(--gray-border);
`;

export default SimilarApps;
